export class MailsSearchFromBroadcast {
  id: number;
  objet: string;
  canViewMail: boolean;
  messageId: string;
  guid: string;
  scanLotCompleted: boolean;
}
